import firebase from "firebase/app";
import "firebase/database";
import { firebaseConfig } from "./firebaseConfig";

firebase.initializeApp(firebaseConfig);

const database = firebase.database();
const contentRef = database.ref(); 
export { contentRef };